import {
  $post, $get, $JsonPost, ebopo,
} from '@/utils/axios-request';


class Sign {
  // 新版本登录
  public async newLogin(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/user/api/v1/login`, postData);
  }
  // 检查登录名
  public async checkLoginName(postData: any): Promise<any> {
      return await $JsonPost(`${ebopo}//user/api/v1/user/count`, postData);
  }

  // login
  public async login(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/user/api/v1/login`, postData);
  }

  // getVerificationCodeToken 先获取验证码token 再获取验证码
  public async getVerificationCodeToken(postData: any): Promise<any> {
    return await $get(`${ebopo}/user/api/v1/getVerificationCodeToken`, postData);
  }

  // getVerificationCode
  public async getVerificationCode(postData: any): Promise<any> {
    return await $get(`${ebopo}/user/api/v1/getVerificationCodeToken`, postData);
  }

  //  课程密码获取课程相关数据
  public async getCoursePasswordToObtainCourseRelatedData(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/study/api/v1/getCoursePasswordToObtainCourseRelatedData`, postData);
  }

  //  个人中心 中获取课程相关的数据
  public async getObtainCourseRelatedDataByCoursePassword(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/study/api/v1/getObtainCourseRelatedDataByCoursePassword`, postData);
  }

  // 获取年级列表
  public async queryGradeList(postData: any): Promise<any> {
    return await $post(`${ebopo}/iuser/api/v1/queryGradeList`, postData);
  }

  // 获取班级列表
  public async queryClassList(postData: any): Promise<any> {
    return await $get(`${ebopo}/iuser/api/v1/queryCanChooseClass`, postData);
  }

  // 省市获取
  public async queryProvence(postData: any): Promise<any> {
    return await $get(`${ebopo}/iuser/api/v1/queryProvence`, postData);
  }

  // 注册
  public async register(postData: any): Promise<any> {
    return await $post(`${ebopo}/user/api/v1/webRegister`, postData);
  }

  public async newRegister(postData: any): Promise<any> {
    return await $post(`${ebopo}/user/api/v1/webRegister`, postData);
  }


  // 登出
  public async logout(): Promise<any> {
    return await $post(`${ebopo}/user/api/v1/logout`, {});
  }

  // 获取修改的用户信息
  public async queryUpdateUserMes(postData: any): Promise<any> {
    return await $post(`${ebopo}/iuser/api/v1/queryUpdateUserMes`, postData);
  }

  // 修改用户信息
  public async updateUser(postData: any): Promise<any> {
    return await $post(`${ebopo}/iuser/api/v1/updateUser`, postData);
  }

  // 修改密码
  public async updatePassword(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/user/api/v1/updatePassword`, postData);
  }

  // 绑定课程
  public async bindProduct(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/study/api/v1/bindProduct`, postData);
  }

  // 修改头像
  public async updateHeaderImg(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/iuser/api/v1/updateHeaderImg`, postData);
  }

  //   获取用户试卷列表
  public async examinationList(postData: any): Promise<any> {
    return await $get(`${ebopo}/Examination/api/v1/getUserExaminationList`, postData);
  }

  // 查询课密
  public async confirmCoursePass(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/admin/v1/confirmCoursePass`, postData);
  }

  // 查看课程包或者价格包详情
  public async getBackPackageDetail(postData: any): Promise<any> {
    return await $get(`${ebopo}/admin/v1/getBackPackageDetail`, postData);
  }
        // 获取学习课程
  public async hasLsCourse(): Promise<any> {
    return await $get(`${ebopo}/iuser/api/v1/hasLsCourse`);
  }
}
export default new Sign();
